module.exports = __webpack_public_path__ + "bin/6d92d57316dadc4d470a6b10a9996ae8.png";